import * as React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import Select from 'react-select';
import ProjectCard from './Cards';
import Loader from '../common/Loader/Loader';
import NotifyHOC from '../../HOC/Notifications';
import SingleValue from '../common/reactSelect/SingleValue';
import IndicatorsContainer from '../common/reactSelect/IndicatorsContainer';

import * as project from '../../mapping/project';
import * as tokenService from '@nexxt/common/firebase/auth/userDetails';
import * as clientService from '../../services/client.service';
import * as Action from '../../actions/project.actions';
import * as projectService from '../../services/project.service';
import * as Cookies from 'js-cookie';

import { PROJECT_SELECTION } from '../../constants/routes';
import { dataTestid } from '../../constants/dataTestid';
import { uppercaseFirstLetter } from '@nexxt/common/services/TextService';
import { STATIC_STORAGE_URL } from '@nexxt/common/constants';
import { HealthProblem, PanelType, Project } from '@nexxt/common/types';
import DuplicateProjectModal from './duplicateProjectModal/DuplicateProjectModal';
import { alertMessage, parseAlertMessage } from '../../constants/alertMessage';
import { IApplicationState } from '../../reducers';
import LinkGeneratorModal from './LinkGeneratorModal';
import { INITIAL_SESSION, PortalSession } from '../../constants/project';
import { PROJECT_EDIT_MODES } from '../../interface/project.interface';
import * as _ from 'lodash';
import { getTenantLevel } from '@nexxt/common/firebase/auth/userDetails';
import CTA from '../common/CTA';
import { TENANT_LEVEL } from '@nexxt/common/types';
import Modal, { ModalBody } from '../common/modal';
import { UilAngleLeft, UilAngleRight, UilPlus } from '@iconscout/react-unicons';
import config from '../../config';
import axios from 'axios';
import { getQueryString } from '@nexxt/common/services/TextService';
import Fuse from 'fuse.js';
interface ProjectProps {
    toastNotification: any;
    projects: any[];
    user: any;
    editMode: PROJECT_EDIT_MODES;
    projectHealth: HealthProblem[];
    fetchProjects: () => Promise<any>;
    clearState: () => void;
    checkProjectHealth: (id: number) => Promise<void>;
    clearProjectHealth: () => void;
}

interface ProjectState {
    tenantId: number;
    clientID: number;
    isRequesting: boolean;
    projects: Array<Project>;
    filteredProjects: Project[];
    clients: any[];
    selectedFilters: {
        status: any;
        client: any;
        owner: any;
    };
    searchValue: string;
    tenantUsers: any[];
    isDuplicateProject: boolean;
    isShareLinksModalOpen: boolean;
    selectedProject: Project;
    duplicatedProject: any;
    session: PortalSession;
    newRapidSolutions: string[];
    whatsnewIndex: number;
    clientTerm: 'Client' | 'Team/Program';
}

class Projects extends React.Component<ProjectProps, ProjectState> {
    constructor(props) {
        super(props);
        this.state = {
            projects: [],
            filteredProjects: [],
            clientID: null,
            tenantId: null,
            isRequesting: false,
            selectedFilters: {
                status: null,
                client: null,
                owner: null
            },
            searchValue: '',
            tenantUsers: [],
            clients: [],
            isDuplicateProject: false,
            isShareLinksModalOpen: false,
            selectedProject: null,
            duplicatedProject: {},
            session: INITIAL_SESSION,
            newRapidSolutions: [],
            whatsnewIndex: 0,
            clientTerm: 'Client'
        };
    }

    async componentDidMount() {
        if (getTenantLevel() === TENANT_LEVEL.SELF_SERVICE) {
            this.setState({ clientTerm: 'Team/Program' });
        }
        const tenantId = tokenService.getTenantId();
        this.setState({ tenantId, isRequesting: true }, async () => {
            const promises = [];
            promises.push(this.loadSession);
            promises.push(this.getClients);
            promises.push(this.getProjects);
            await Promise.all(promises.map((f) => f()));
            this.setState({ isRequesting: false });
        });
    }

    loadSession = async (): Promise<void> => {
        const featuredRapidSolution = getQueryString('rs');
        try {
            const DATA_API_URL = `${config.host.data}/session/load/portal/${this.props.user.id}`;
            const cssToken = Cookies.get('csst');
            const signal = axios.CancelToken.source();
            const res = await axios.get(DATA_API_URL, {
                cancelToken: signal.token,
                headers: { Authorization: `Bearer ${cssToken}` },
                withCredentials: true
            });

            // apply session if it exists
            if (res.status === 200) {
                const loadedSession = {
                    ...INITIAL_SESSION,
                    ...res.data
                };
                const newRapidSolutions = [];

                if (featuredRapidSolution) {
                    // check if user has seen this rapid solution already
                    loadedSession.featuredRapidSolution = featuredRapidSolution;
                    loadedSession.viewed = false;
                } else {
                    if (
                        !loadedSession.lastLoggedIn ||
                        loadedSession.lastLoggedIn.split('T')[0] !==
                            new Date().toISOString().split('T')[0]
                    ) {
                        // find new rapid solutions not seen by user
                        const newRapidSolutionsToBeAdded = Object.keys(
                            loadedSession.seenRapidSolutions
                        ).filter(
                            (solution) =>
                                loadedSession.seenRapidSolutions[solution] ===
                                    false &&
                                loadedSession.featuredRapidSolution !== solution
                        );
                        // show what's new modal if new rapid solutions
                        // and clear and previous featured rapid solutions
                        if (newRapidSolutionsToBeAdded.length > 0) {
                            newRapidSolutions.push(
                                ...newRapidSolutionsToBeAdded
                            );
                            loadedSession.viewed = false;
                            loadedSession.featuredRapidSolution = null;
                        }
                    }
                }
                this.setState({
                    session: loadedSession,
                    newRapidSolutions: newRapidSolutions
                });
            }
        } catch (error) {
            // if package session doesn't exist, use template session
            // apply featured rapid solution if applicable
            this.setState({
                session: {
                    ...INITIAL_SESSION,
                    featuredRapidSolution: featuredRapidSolution
                        ? featuredRapidSolution
                        : INITIAL_SESSION.featuredRapidSolution
                }
            });
        }
    };

    saveSession = async (newSession): Promise<void> => {
        const DATA_API_URL = `${config.host.data}/session/save`;
        const signal = axios.CancelToken.source();
        const body = {
            sessionKey: this.props.user.id,
            sessionContext: 'portal',
            sessionObject: newSession
        };

        try {
            const cssToken = Cookies.get('csst');
            await axios.post(DATA_API_URL, body, {
                cancelToken: signal.token,
                headers: { Authorization: `Bearer ${cssToken}` },
                withCredentials: true
            });
            this.setState({ session: newSession });
        } catch (error) {
            console.log('ERROR! Could not save session:', error);
        }
    };

    /**
     * Function to get all projects.
     */
    getProjects = async (refresh = false) => {
        try {
            if (!this.props.projects.length || refresh) {
                const response = await this.props.fetchProjects();
                const tenantUsers = _.uniq(
                    response.data.data.map((p) => p.lastModifiedBy)
                ).map((name) => {
                    return { value: name, label: name };
                });
                this.setState({
                    projects: response.data.data,
                    filteredProjects: response.data.data,
                    tenantUsers: tenantUsers
                });
            } else {
                this.setState({
                    projects: this.props.projects,
                    filteredProjects: this.props.projects
                });
            }
        } catch (error) {
            console.error(error);
            this.props.toastNotification.error(
                alertMessage.UNABLE_FETCH_PROJECTS
            );
        }
    };

    /**
     * Function to get client list to show in client dropdown.
     */
    getClients = async () => {
        try {
            const response = await clientService.fetchClients(
                this.state.tenantId
            );
            this.setState({
                clients: response.data.data
            });
        } catch (error) {
            this.props.toastNotification.error(
                _.template(alertMessage.UNABLE_GET_CLIENT_LIST_t)({
                    clientName: this.state.clientTerm
                })
            );
        }
    };

    /**
     * Function to handle all filters.
     */
    handleFilterSelect = (filterKey, filterValue) => {
        this.setState(
            {
                selectedFilters: {
                    ...this.state.selectedFilters,
                    [filterKey]: filterValue
                }
            },
            this.handleFilter
        );
    };

    /**
     * Function to fetch project without any filter.
     */
    fetchProjects = async () => {
        try {
            const response = await this.props.fetchProjects();
            this.setProjectInState(response);
        } catch (e) {
            throw e;
        }
    };

    setProjectInState = (response) => {
        this.setState({
            projects: response.data.data,
            isRequesting: false
        });
    };

    /**
     * Function to reset filters.
     */
    resetFilters = () => {
        this.setState({
            selectedFilters: { status: null, client: null, owner: null },
            searchValue: ''
        });
        this.getProjects();
    };

    /**
     * Return true if any filter is active.
     */
    isSomeFilterActive = () => {
        return (
            Object.values(this.state.selectedFilters).some((f) => f) ||
            this.state.searchValue.length
        );
    };

    onSearch = (event) => {
        this.setState(
            {
                searchValue: event.target.value
            },
            this.handleFilter
        );
    };

    handleFilter = () => {
        const { selectedFilters, searchValue, projects } = this.state;
        const { owner, status, client } = selectedFilters;
        const isEmptySearch = !searchValue;

        /** Filter by Status / Client / Owner */
        const filteredByDropdown = projects.filter((proj) => {
            const statusMatch =
                !status ||
                status.value === proj.status ||
                status.value === 'ALL';
            const ownerMatch = !owner || owner.value === proj.regBy;
            const clientMatch = !client || client.value === proj.client;

            return statusMatch && ownerMatch && clientMatch;
        });
        let filteredProjects = filteredByDropdown;
        if (!isEmptySearch) {
            const filteredProjectsWithFilterKey = filteredByDropdown.map(
                (p) => ({ ...p, searchKey: `${p.name} ${p.codeName} ${p.id}` })
            );
            const searchOptions = {
                includeMatches: true,
                includeScore: true,
                ignoreLocation: true,
                keys: ['name', 'codeName', 'id'],
                threshold: 0,
                sortFn: (a, b) => b.lastModifiedOn - a.lastModifiedOn
            };

            const fuse = new Fuse(filteredProjectsWithFilterKey, searchOptions);
            filteredProjects = fuse
                .search(searchValue)
                .map((search) => search.item);
        }

        this.setState({ filteredProjects });
    };

    clearProject = () => {
        this.props.clearState();
    };

    clearState = (callback = () => {}) => {
        this.setState(
            {
                selectedFilters: { status: null, client: null, owner: null },
                clientID: null
            },
            callback
        );
    };

    duplicateProjectToggle = async () => {
        this.setState({
            isDuplicateProject: !this.state.isDuplicateProject
        });
    };

    setDuplicateProject = (project) => {
        this.setState({
            duplicatedProject: project
        });
    };

    createDuplicateProject = async (values: any, { setSubmitting }) => {
        this.setState({
            isRequesting: true
        });

        const { duplicatedProject } = this.state;
        try {
            await projectService.duplicateProject(duplicatedProject.id, {
                name: values.projectName
            });
            this.getProjects(true);
            this.props.toastNotification.success(
                parseAlertMessage(
                    alertMessage.SUCCESS_DUPLIATE_PROJECT,
                    uppercaseFirstLetter(duplicatedProject.name)
                )
            );
            this.duplicateProjectToggle();
            setSubmitting(false);
            this.setState({
                isRequesting: false
            });
        } catch (err) {
            this.props.toastNotification.error(
                parseAlertMessage(
                    alertMessage.UNABLE_DUPLICATE_PROJECT,
                    uppercaseFirstLetter(duplicatedProject.name)
                )
            );
            this.getProjects();
            setSubmitting(false);
            this.setState({
                isRequesting: false
            });
        }
    };

    toggleShareLinkModal = (project?) => {
        this.setState({
            isShareLinksModalOpen: !this.state.isShareLinksModalOpen,
            selectedProject: project ? project : null
        });
    };

    getRapidSolution = (rapidSolutionID) => {
        const rapidSolution = project.packagedSolution.find(
            (solution) => solution.rapidSolutionID === rapidSolutionID
        );
        return rapidSolution;
    };
    redirectToProjectSelect = async (solution) => {
        try {
            await this.saveSession({
                ...this.state.session,
                seenRapidSolutions: {
                    ...this.state.session.seenRapidSolutions,
                    [solution.rapidSolutionID]: true
                },
                viewed: true,
                lastLoggedIn: new Date()
            });
            window.location.assign(`/projects/new/select`);
        } catch (err) {
            console.log(err);
        }
    };

    render() {
        const {
            isRequesting,
            selectedFilters,
            tenantUsers,
            clients,
            searchValue,
            session,
            newRapidSolutions,
            whatsnewIndex,
            filteredProjects
        } = this.state;

        const tenantLevel = getTenantLevel();
        const isWizard = tenantLevel === TENANT_LEVEL.INCA_WIZARD;
        const { featuredRapidSolution, viewed: viewedGettingStarted } = session;

        const featuredRapidSolutionData = this.getRapidSolution(
            featuredRapidSolution
        );
        const newRapidSolutionData = newRapidSolutions.map((rs, i) =>
            this.getRapidSolution(newRapidSolutions[i])
        );
        return (
            <>
                {isWizard && !isRequesting && !viewedGettingStarted ? (
                    featuredRapidSolution ? (
                        <Modal
                            className="project-directory--modal--container"
                            isOpen={!viewedGettingStarted}
                        >
                            <ModalBody>
                                <div className="project-directory--modal">
                                    <span className="project-directory--modal--title">
                                        Welcome to inca&apos;s
                                        <br />
                                        {featuredRapidSolutionData.title}
                                    </span>
                                    <div className="project-directory--modal--body">
                                        <p>As a demo account user:</p>
                                        <ul className="project-directory--modal--body--list">
                                            <li>
                                                All test projects are FREE of
                                                charge
                                            </li>
                                            <li>
                                                Respondent data will not be
                                                collected from test surveys
                                            </li>
                                            <li>
                                                All data and displays are for
                                                demo purposes only
                                            </li>
                                        </ul>
                                    </div>
                                    <button
                                        className="btn btn--lg btn--green"
                                        onClick={() =>
                                            this.redirectToProjectSelect(
                                                featuredRapidSolutionData
                                            )
                                        }
                                    >
                                        Get Started
                                    </button>
                                </div>
                            </ModalBody>
                        </Modal>
                    ) : this.state.newRapidSolutions.length > 0 ? (
                        <Modal
                            className="project-directory--modal--container --whatsnew"
                            isOpen={this.state.newRapidSolutions.length > 0}
                        >
                            <ModalBody>
                                <div className="project-directory--modal --whatsnew">
                                    <span className="project-directory--modal--header">
                                        What&apos;s New
                                    </span>
                                    <span className="project-directory--modal--title">
                                        {
                                            newRapidSolutionData[whatsnewIndex]
                                                .title
                                        }
                                    </span>
                                    <p className="project-directory--modal--subtitle">
                                        {
                                            newRapidSolutionData[whatsnewIndex]
                                                .body
                                        }
                                    </p>
                                    <div className="project-selection--card-expanded--images">
                                        <div className="project-selection--card-expanded--images--item">
                                            <img
                                                className="project-selection--card-expanded--images--chat"
                                                src={`${STATIC_STORAGE_URL}/img/portal/packaged-solutions/${newRapidSolutionData[
                                                    whatsnewIndex
                                                ].title
                                                    .toLowerCase()
                                                    .split(' ')
                                                    .join('-')}-chat.png`}
                                            />
                                        </div>
                                        <div className="project-selection--card-expanded--images--item">
                                            <img
                                                className="project-selection--card-expanded--images--dashboard"
                                                src={`${STATIC_STORAGE_URL}/img/portal/packaged-solutions/${newRapidSolutionData[
                                                    whatsnewIndex
                                                ].title
                                                    .toLowerCase()
                                                    .split(' ')
                                                    .join('-')}-dashboard.png`}
                                            />
                                        </div>
                                    </div>
                                    <button
                                        className="btn btn--lg btn--green"
                                        onClick={() =>
                                            this.redirectToProjectSelect(
                                                newRapidSolutionData
                                            )
                                        }
                                    >
                                        Get Started
                                    </button>
                                    <div className="project-directory--modal--controls">
                                        <div
                                            className="project-directory--modal--controls--item"
                                            onClick={() => {
                                                if (whatsnewIndex > 0) {
                                                    this.setState({
                                                        whatsnewIndex:
                                                            this.state
                                                                .whatsnewIndex -
                                                            1
                                                    });
                                                }
                                            }}
                                        >
                                            {whatsnewIndex > 0 && (
                                                <UilAngleLeft size={40} />
                                            )}
                                        </div>
                                        <div
                                            className="project-directory--modal--controls--item"
                                            onClick={() => {
                                                if (
                                                    whatsnewIndex <
                                                    newRapidSolutions.length - 1
                                                ) {
                                                    this.setState({
                                                        whatsnewIndex:
                                                            this.state
                                                                .whatsnewIndex +
                                                            1
                                                    });
                                                }
                                            }}
                                        >
                                            {whatsnewIndex <
                                                newRapidSolutions.length -
                                                    1 && (
                                                <UilAngleRight size={40} />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </ModalBody>
                        </Modal>
                    ) : null
                ) : null}
                <div className="card-grid-container card-contianer--project">
                    <div className="flex gap-4 justify-between mb-4">
                        <div className="filters mb-0">
                            <div className="filters--search">
                                <input
                                    type="text"
                                    name="name"
                                    placeholder="Search by Project Name, URL or ID"
                                    onChange={this.onSearch}
                                />
                                <i className="nx nx-search" />
                            </div>
                            <div className="filters--filter-status">
                                <Select
                                    name="form-field-name"
                                    value={selectedFilters.status}
                                    options={project.status}
                                    onChange={(selection) =>
                                        this.handleFilterSelect(
                                            'status',
                                            selection
                                        )
                                    }
                                    placeholder="Select Status"
                                    components={{
                                        SingleValue,
                                        FilterValue: () => (
                                            <span>Status: </span>
                                        ),
                                        IndicatorsContainer
                                    }}
                                    classNamePrefix="react-select"
                                    className="react-select"
                                    //menuIsOpen={true}
                                />
                            </div>
                            <div className="filters--filter-client">
                                <Select
                                    className="react-select"
                                    name="form-field-name"
                                    value={selectedFilters.client}
                                    options={clients}
                                    onChange={(selection) =>
                                        this.handleFilterSelect(
                                            'client',
                                            selection
                                        )
                                    }
                                    placeholder={`Select ${this.state.clientTerm}`}
                                    components={{
                                        SingleValue,
                                        FilterValue: () => (
                                            <span>
                                                {this.state.clientTerm}:{' '}
                                            </span>
                                        ),
                                        IndicatorsContainer
                                    }}
                                    classNamePrefix="react-select"
                                />
                            </div>
                            <div className="filters--filter-client">
                                <Select
                                    className="react-select"
                                    name="form-field-name"
                                    value={selectedFilters.owner}
                                    options={tenantUsers}
                                    onChange={(selection) =>
                                        this.handleFilterSelect(
                                            'owner',
                                            selection
                                        )
                                    }
                                    placeholder="Select Owner"
                                    components={{
                                        SingleValue,
                                        FilterValue: () => <span>Owner: </span>,
                                        IndicatorsContainer
                                    }}
                                    classNamePrefix="react-select"
                                />
                            </div>
                            <div className="form-group m-0">
                                <button
                                    disabled={!this.isSomeFilterActive()}
                                    type="button"
                                    className="btn btn--md btn--blue"
                                    onClick={this.resetFilters}
                                >
                                    Reset Filters
                                </button>
                            </div>
                        </div>
                        <div className="flex items-center">
                            <span className="whitespace-nowrap">
                                {`Project Credits Available: ${this.props.user.defaultTenant.availableProjects}`}
                            </span>
                        </div>
                    </div>

                    {this.state.isDuplicateProject &&
                    Object.keys(this.state.duplicatedProject).length != 0 ? (
                        <DuplicateProjectModal
                            projectHealth={this.props.projectHealth}
                            checkProjectHealth={this.props.checkProjectHealth}
                            duplicatedProject={this.state.duplicatedProject}
                            duplicateProjectToggle={this.duplicateProjectToggle}
                            handleSubmit={this.createDuplicateProject}
                            onClose={this.duplicateProjectToggle}
                            clearProjectHealth={this.props.clearProjectHealth}
                        />
                    ) : null}
                    {this.state.isShareLinksModalOpen && (
                        <LinkGeneratorModal
                            onClose={this.toggleShareLinkModal}
                            project={this.state.selectedProject}
                            user={this.props.user}
                            hidePanel={
                                this.state.selectedProject.panelSettings
                                    ?.panelType === PanelType.INCA
                            }
                            isWizard={isWizard}
                        />
                    )}
                    {isRequesting ? (
                        <Loader />
                    ) : (
                        <div className="cards grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4">
                            <React.Fragment>
                                <Link
                                    to={PROJECT_SELECTION}
                                    data-test={dataTestid.NEW_PROJECT_BTN}
                                    className="h-56 w-full bg-blue text-white font-semibold rounded text-xl flex flex-col justify-center items-center hover:no-underline hover:drop-shadow-md"
                                    onClick={this.clearProject}
                                >
                                    <UilPlus size={48} />
                                    <span className="card-text mt-2">
                                        New Project
                                    </span>
                                </Link>
                                {filteredProjects &&
                                    filteredProjects
                                        .filter(
                                            (project) => project.tenantID !== -1
                                        )
                                        .map((project, index) => {
                                            return (
                                                <ProjectCard
                                                    allProjects={
                                                        this.state.projects
                                                    }
                                                    project={project}
                                                    key={index}
                                                    getProjects={
                                                        this.getProjects
                                                    }
                                                    tenantId={
                                                        this.state.tenantId
                                                    }
                                                    clearState={this.clearState}
                                                    duplicateProjectToggle={
                                                        this
                                                            .duplicateProjectToggle
                                                    }
                                                    setDuplicateProject={
                                                        this.setDuplicateProject
                                                    }
                                                    toggleShareLinkModal={
                                                        this
                                                            .toggleShareLinkModal
                                                    }
                                                    isShareLinksModalOpen={
                                                        this.state
                                                            .isShareLinksModalOpen
                                                    }
                                                />
                                            );
                                        })}
                                {/* {isSandboxMode && (
                                <ProjectCard
                                    key={this.state.projects.length}
                                    allProjects={this.state.projects}
                                    project={SANDBOX_PROJECT}
                                    getProjects={this.getProjects}
                                    tenantId={this.state.tenantId}
                                    clearState={this.clearState}
                                    duplicateProjectToggle={
                                        this.duplicateProjectToggle
                                    }
                                    setDuplicateProject={
                                        this.setDuplicateProject
                                    }
                                    toggleShareLinkModal={
                                        this.toggleShareLinkModal
                                    }
                                    isShareLinksModalOpen={
                                        this.state.isShareLinksModalOpen
                                    }
                                />
                            )} */}
                            </React.Fragment>
                        </div>
                    )}
                    {isWizard && !isRequesting && (
                        <>
                            <div className="project-header">
                                {/* <UilClipboardAlt size={32} /> */}
                                <span className="project-header--title">
                                    Demos
                                </span>
                                <p className="project-header--content">
                                    Our pre-built chat and dashboard templates
                                    will show you what your participants will
                                    see/experience and how your results will be
                                    visualized.
                                </p>
                            </div>
                            <div className="cards grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                                {filteredProjects &&
                                    filteredProjects
                                        .filter(
                                            (project) => project.tenantID === -1
                                        )
                                        .map((project, index) => {
                                            return (
                                                <ProjectCard
                                                    allProjects={
                                                        this.state.projects
                                                    }
                                                    project={project}
                                                    key={index}
                                                    getProjects={
                                                        this.getProjects
                                                    }
                                                    tenantId={
                                                        this.state.tenantId
                                                    }
                                                    clearState={this.clearState}
                                                    duplicateProjectToggle={
                                                        this
                                                            .duplicateProjectToggle
                                                    }
                                                    setDuplicateProject={
                                                        this.setDuplicateProject
                                                    }
                                                    toggleShareLinkModal={
                                                        this
                                                            .toggleShareLinkModal
                                                    }
                                                    isShareLinksModalOpen={
                                                        this.state
                                                            .isShareLinksModalOpen
                                                    }
                                                    hideDate={true}
                                                    clientTerm={
                                                        this.state.clientTerm
                                                    }
                                                />
                                            );
                                        })}
                            </div>
                        </>
                    )}
                </div>
                {isWizard && viewedGettingStarted && <CTA condensed={true} />}
            </>
        );
    }
}

const mapStateToProps = (store: IApplicationState) => {
    const {
        projectReducer: { projects, editMode, projectHealth },
        authReducer: { user }
    } = store;
    return {
        projects,
        user,
        editMode,
        projectHealth
    };
};

const mapDispatchToProps = (dispatch) => ({
    fetchProjects: () => dispatch(projectService.fetchProjects()),
    clearState: () => {
        dispatch(Action.clearProjects());
    },
    clearProjectHealth: () => dispatch(Action.clearProjectHealth()),
    checkProjectHealth: (projectID: number) =>
        dispatch(projectService.checkProjectHealth(projectID))
});

export default NotifyHOC(
    connect(mapStateToProps, mapDispatchToProps)(Projects)
);
